import logo from '../assets/tkms_logo.svg';

const tkmsTheme = {
  logo: logo,
  colors: {
    black: "#333",
    white: "#fff",
    whiteTrans: "rgba(255,255,255,0.9)",
    grey: " #EDEDED",
    darkGrey: " #999",
    text: "#1a1a1a",
    primary: "#fffa9a",
    background: "#fff",
    buttonBackground: "#fffa9a",
    buttonText: "#000000",
    highlight: "#ffbf26",
    borderColor: "#ffffff",
    selectedColor: "#ffbf26",
    iconColor: '#000000',
  },
  fonts: {
    Headline: "TKMSHead, Helvetica, Arial, sans-serif",
    Button: "TKMS, Helvetica, Arial, sans-serif",
    Copy: "TKMS, Helvetica, Arial, sans-serif"
  }
};

export default tkmsTheme;
